module.exports = __webpack_public_path__ + "static/media/spinner.c38d59b0.gif";